import isFunction from 'lodash/isFunction';

export const shouldCraftIgnoreEvent = (e?: any) => {
  if (document.activeElement?.getAttribute('data-craft-ignore-events') === 'true') {
    return true;
  }
  const path = e?.composedPath ? e?.composedPath() || [] : [];
  const viewportIndex = path.findIndex((elem: HTMLElement) => elem?.id === 'viewport');
  return path
    .slice(0, viewportIndex)
    .find(
      (elem: HTMLElement) =>
        isFunction(elem?.getAttribute) && elem?.getAttribute('data-craft-ignore-events') === 'true',
    );
};
